export default "__VITE_ASSET__Bd$70r$6__"